var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppMenuItem,{attrs:{"app":_setup.entry,"compact":_vm.compact,"tabindex":_vm.tabindex},on:{"click":_setup.onClick},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(_setup.AppActionIcon,{attrs:{"icon":_vm.action.icon,"color":_vm.action.color}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }